import React, { } from 'react';
import { Box, Flex, Input } from '@chakra-ui/react';
import { Context } from '../App';
import { SPACING } from './config';
import Divider from '../base-components/Divider';

const Searcher = <T extends {}>({
    children,
    onChange,
    // isSearching,
}: {
    children?: React.ReactNode,
    title: string,
    description: string,
    onChange: (value: string) => void,
    // isSearching: boolean,
}) => {
    const { translations } = React.useContext(Context);

    return (
        <Box>
            <Flex gap={SPACING}>
                <Box flexGrow={1}>
                    <Input my={SPACING} title={translations.model.companySettings.name} name="name" onChange={(e) => onChange(e.target.value)} />
                </Box>
                {children}
            </Flex>
            <Divider />
        </Box>
    );
}

export default Searcher;
